"use client";

import { Box, Container } from "@chakra-ui/react";
import { FreeDiscoveryCallForm } from "./FreeDiscoveryCallForm";
import { deepBlueSky } from "@/styles/theme";
export const CoacheeContactForm = () => {
  return (
    <Box w="full" bgColor={deepBlueSky} id="schedule">
      <Container maxW="container.xl">
        <FreeDiscoveryCallForm coachee />
      </Container>
    </Box>
  );
};
